'use strict';

var _hyphenPattern = /-(.)/g;

/**
 * Convert a string to camel case.
 *
 * @param  {String} string - The string.
 * @return {String}
 */
function camelCase(string) {
    if (typeof string !== 'string') { // null is an object
        throw new TypeError('First argument must be a string');
    }
    if(string.indexOf('-') < 0) {
        return string;
    }
    return string.toLowerCase().replace(_hyphenPattern, function(_, character) {
        return character.toUpperCase();
    });
}

/**
 * Swap key with value in an object.
 *
 * @param  {Object}   obj        - The object.
 * @param  {Function} [override] - The override method.
 * @return {Object}              - The inverted object.
 */
function invertObject(obj, override) {
    if (typeof obj !== 'object' || !obj) { // null is an object
        throw new TypeError('First argument must be an object');
    }

    var key;
    var value;
    var isOverridePresent = typeof override === 'function';
    var overrides = {};
    var result = {};

    for (key in obj) {
        value = obj[key];

        if (isOverridePresent) {
            overrides = override(key, value);
            if (overrides && overrides.length === 2) {
                result[overrides[0]] = overrides[1];
                continue;
            }
        }

        if (typeof value === 'string') {
            result[value] = key;
        }
    }

    return result;
}

/**
 * Export utilties.
 */
module.exports = {
    camelCase: camelCase,
    invertObject: invertObject
};



//////////////////
// WEBPACK FOOTER
// ./~/html-react-parser/lib/utilities.js
// module id = 83
// module chunks = 195234328731080 241203398517478